import { useState } from "react";
import { Divider, FilledButton, Form, OutlinedTextField, Radio, RadioGroup, Switch } from "../../../../common/components";
import { AccountSelfCreation } from "../../../../viewModels/configuration/accountSelfCreation";

import styles from './AccountSelfCreationDetailPane.module.scss';
import { ApprovalRequestEmail } from "../../../../viewModels/configuration/approvalRequestEmail";
import { VisibilityOption } from "../../../../viewModels/configuration/visibilityOption";
import { AccountSelfCreationConfiguration } from "./accountSelfCreationConfiguration/AccountSelfCreationConfiguration";
import { AccountSelfCreationConfigurationNoButton } from "./accountSelfCreationConfigurationNoButton/AccountSelfCreationConfigurationNoButton";
import { usePageStrings } from "../../../../common/hooks";
import { useTranslation } from "react-i18next";


interface IComponentProperties {
    onSubmit: Function,
    accountSelfCreationSettings: AccountSelfCreation
  };
  
  export function AccountSelfCreationDetailPane (props: IComponentProperties) {
    const pageStrings = usePageStrings();    
    const { t } = useTranslation();
    const [accountSelfCreationEnabled, setAccountSelfCreationEnabled] = useState(props.accountSelfCreationSettings.isEnabled===true);
    const [approvalRequiredEnabled, setApprovalRequiredEnabled] = useState(props.accountSelfCreationSettings.approvalRequired_IsEnabled===true);   
    const [approvalRequiredSpecificEmailAddress, setApprovalRequiredSpecificEmailAddress] = useState(props.accountSelfCreationSettings.approvalRequired_SpecificEmailAddress);
    const [approvalRequestEmailSelected, setApprovalRequestEmailSelected] = useState(approvalRequestEmailInitialValue(props.accountSelfCreationSettings.approvalRequired_SentTo));    
    const [departmentSelection, setDepartmentSelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_Department));
    const [locationSelection, setLocationSelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_Location));
    const [practiceAreaSelection, setPracticeAreaSelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_PracticeArea));
    const [telephoneSelection, setTelephoneSelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_Telephone));
    const [titleSelection, setTitleSelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_Title));
    const [userProfileSelection, setUserProfileSelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_UserProfile));

    
    const [street1Selection, setStreet1Selection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_Street1));
    const [street2Selection, setStreet2Selection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_Street2));
    const [citySelection, setCitySelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_City));
    const [stateSelection, setStateSelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_State));
    const [countrySelection, setCountrySelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_Country));
    const [zipCodeSelection, setZipCodeSelection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_ZipCode));

    const [userCustomString1Selection, setUserCustomString1Selection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_UserCustomString1));
    const [userCustomString2Selection, setUserCustomString2Selection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_UserCustomString2));
    const [userCustomString3Selection, setUserCustomString3Selection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_UserCustomString3));
    const [userCustomString4Selection, setUserCustomString4Selection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_UserCustomString4));
    const [userCustomString5Selection, setUserCustomString5Selection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_UserCustomString5));
    const [userCustomString6Selection, setUserCustomString6Selection] = useState(visibilityOptionInitialValue(props.accountSelfCreationSettings.formConfiguration_UserCustomString6));
   
    function handleRequestEmailMethodChanged(selectedValue:any) {
        setApprovalRequestEmailSelected(selectedValue);    
    }

    function handleApprovalRequiredClick() {  
        setApprovalRequiredEnabled(!approvalRequiredEnabled); 
    }

    function handleAccountSelfCreationClick() {  
        setAccountSelfCreationEnabled(!accountSelfCreationEnabled);  
        if(accountSelfCreationEnabled) 
        {
            setApprovalRequiredEnabled(false); 
        }
    }

    function handleDepartmentSelection(selectedValue:VisibilityOption) {  
        setDepartmentSelection(selectedValue);   
    }

    function handleLocationSelection(selectedValue:VisibilityOption) {  
        setLocationSelection(selectedValue);   
    }

    function handlePracticeAreaSelection(selectedValue:VisibilityOption) {  
        setPracticeAreaSelection(selectedValue);   
    }

    function handleTelephoneSelection(selectedValue:VisibilityOption) {  
        setTelephoneSelection(selectedValue);   
    }

    function handleTitleSelection(selectedValue:VisibilityOption) {  
        setTitleSelection(selectedValue);   
    }


    function handleUserProfileSelection(selectedValue:VisibilityOption) {  
        setUserProfileSelection(selectedValue);   
    }

    function handleUserCustomString1Selection(selectedValue:VisibilityOption) {   
        setUserCustomString1Selection(selectedValue); 
    }
    function handleUserCustomString2Selection(selectedValue:VisibilityOption) {   
        setUserCustomString2Selection(selectedValue); 
    }
    function handleUserCustomString3Selection(selectedValue:VisibilityOption) {   
        setUserCustomString3Selection(selectedValue); 
    }
    function handleUserCustomString4Selection(selectedValue:VisibilityOption) {   
        setUserCustomString4Selection(selectedValue); 
    }
    function handleUserCustomString5Selection(selectedValue:VisibilityOption) {   
        setUserCustomString5Selection(selectedValue); 
    }
    function handleUserCustomString6Selection(selectedValue:VisibilityOption) {   
        setUserCustomString6Selection(selectedValue); 
    }

    function handleApprovalRequiredSpecificEmailChanged (e: any){
        setApprovalRequiredSpecificEmailAddress(e.target.value);
    }

    function handleStreet1Selection(selectedValue:VisibilityOption) {   
        setStreet1Selection(selectedValue); 
    }
    function handleStreet2Selection(selectedValue:VisibilityOption) {   
        setStreet2Selection(selectedValue); 
    }
    function handleCitySelection(selectedValue:VisibilityOption) {   
        setCitySelection(selectedValue); 
    }
    function handleStateSelection(selectedValue:VisibilityOption) {   
        setStateSelection(selectedValue); 
    }
    function handleCountrySelection(selectedValue:VisibilityOption) {   
        setCountrySelection(selectedValue); 
    }
    function handleZipCodeSelection(selectedValue:VisibilityOption) {   
        setZipCodeSelection(selectedValue); 
    }

    function handleFormSubmit (formData: AccountSelfCreation) {
        if(accountSelfCreationEnabled)
        {
            formData.isEnabled = accountSelfCreationEnabled;
            formData.approvalRequired_IsEnabled = approvalRequiredEnabled;
            formData.approvalRequired_SentTo = approvalRequestEmailSelected;                            
            formData.approvalRequired_SpecificEmailAddress = approvalRequiredSpecificEmailAddress || "";
            formData.formConfiguration_Department = departmentSelection;
            formData.formConfiguration_Location = locationSelection;
            formData.formConfiguration_PracticeArea = practiceAreaSelection;
            formData.formConfiguration_Telephone = telephoneSelection;
            formData.formConfiguration_Title = titleSelection;
            formData.formConfiguration_UserProfile =  userProfileSelection;

            formData.formConfiguration_Street1 =  street1Selection;
            formData.formConfiguration_Street2 =  street2Selection;
            formData.formConfiguration_City =  citySelection;
            formData.formConfiguration_State =  stateSelection;
            formData.formConfiguration_Country =  countrySelection;
            formData.formConfiguration_ZipCode =  zipCodeSelection;



            formData.formConfiguration_UserCustomString1 =  userCustomString1Selection;
            formData.formConfiguration_UserCustomString2 =  userCustomString2Selection;
            formData.formConfiguration_UserCustomString3 =  userCustomString3Selection;
            formData.formConfiguration_UserCustomString4 =  userCustomString4Selection;
            formData.formConfiguration_UserCustomString5 =  userCustomString5Selection;
            formData.formConfiguration_UserCustomString6 =  userCustomString6Selection;


            formData.approvalRequired_SentTo =  parseInt(approvalRequestEmailSelected.toString());
        }
        props.onSubmit(formData);
    }
    
    return (
        <>
        
            <Form onSubmit={handleFormSubmit} className={styles['AccountSelfCreationDetailPane']}>
                <div className={styles['AccountSelfCreationDetailPane-enabledSection']}>
                    <Switch  
                        name="isEnabled" 
                        label ={pageStrings.accountSelfCreationPage.switch_accountSelfCreation_label} 
                        ariaLabel={pageStrings.accountSelfCreationPage.switch_accountSelfCreation_ariaLabel} 
                        selected = {accountSelfCreationEnabled} 
                        onChanged={handleAccountSelfCreationClick}
                    ></Switch>
                </div>
                <Divider></Divider>
                <div className={styles['AccountSelfCreationDetailPane-approvalRequiredSection']} >
                    <Switch 
                        name="approvalRequired_IsEnabled" 
                        label ={pageStrings.accountSelfCreationPage.switch_approvalRequired_label} 
                        ariaLabel={pageStrings.accountSelfCreationPage.switch_approvalRequired_ariaLabel}
                        selected = {approvalRequiredEnabled}  
                        onChanged={handleApprovalRequiredClick}
                        disabled = {accountSelfCreationEnabled===false}
                    ></Switch>
                    {approvalRequiredEnabled === true  &&
                    < >
                        <RadioGroup label={pageStrings.accountSelfCreationPage.radio_approvalRequestEmail_label}>
                            <Radio labelText={pageStrings.accountSelfCreationPage.radio_approvalRequestEmail_doNotSend_option} name="approvalRequired_SentTo" 
                                checked={approvalRequestEmailSelected.toString() === ApprovalRequestEmail.DontSend.toString()} 
                                value={ApprovalRequestEmail.DontSend.toString()}
                                onChanged={handleRequestEmailMethodChanged}
                            ></Radio>
                            <Radio labelText={pageStrings.accountSelfCreationPage.radio_approvalRequestEmail_SystemAdministrator_option} name="approvalRequired_SentTo" 
                                checked={approvalRequestEmailSelected.toString() === ApprovalRequestEmail.SendToSystemAdministrator.toString() } 
                                value={ApprovalRequestEmail.SendToSystemAdministrator.toString()}
                                onChanged={handleRequestEmailMethodChanged}
                                ></Radio>
                            <Radio labelText={pageStrings.accountSelfCreationPage.radio_approvalRequestEmail_SpecificEmailAddress_option} name="approvalRequired_SentTo" 
                                checked={approvalRequestEmailSelected.toString() === ApprovalRequestEmail.SendToSpecificEmailAddress.toString() } 
                                value={ApprovalRequestEmail.SendToSpecificEmailAddress.toString()} 
                                onChanged={handleRequestEmailMethodChanged}
                                ></Radio>
                        </RadioGroup> 
                        <OutlinedTextField 
                            label={pageStrings.accountSelfCreationPage.formItem_emailAddress_label} 
                            type="text"
                            name="approvalRequired_SentTo"          
                            placeholder={pageStrings.accountSelfCreationPage.formItem_emailAddress_label} 
                            value={approvalRequiredSpecificEmailAddress}
                            disabled = {approvalRequestEmailSelected.toString() !== ApprovalRequestEmail.SendToSpecificEmailAddress.toString()}
                            required 
                            pattern={`^(?=.{6,359}$)((?:(?:(?:[À-ǿa-zA-Z0-9][\\-._']?)*)[À-ǿa-zA-Z0-9]+)@{1}(?:(?:(?:[À-ǿa-zA-Z0-9][\\-._']?)*)[À-ǿa-zA-Z0-9]+)[.]{1}[À-ǿa-zA-Z]{2,63})$`}
                            onChange={handleApprovalRequiredSpecificEmailChanged}
                        ></OutlinedTextField> 
                            
                    </>}
                </div>
                <div className={styles['AccountSelfCreationDetailPane-blank']}></div>
                <Divider></Divider>
                <section className={styles['AccountSelfCreationDetailPane-formConfigurationSection']}>
                    <h3>
                        <span className={styles["AccountSelfCreationDetailPane-formConfigurationSection-headerText"]}>{t(pageStrings.accountSelfCreationPage.heading_formConfiguration)}
                            </span>
                    </h3>
                    <div className={styles['AccountSelfCreationDetailPane-formConfigurationOptions']}>
                        <AccountSelfCreationConfigurationNoButton 
                            value={pageStrings.accountSelfCreationPage.formItem_formConfiguration_required_option}  
                            label={pageStrings.accountSelfCreationPage.formItem_firstName_label} 
                        ></AccountSelfCreationConfigurationNoButton>          
                        <AccountSelfCreationConfigurationNoButton 
                            value={pageStrings.accountSelfCreationPage.formItem_formConfiguration_required_option}  
                            label={pageStrings.accountSelfCreationPage.formItem_lastName_label} 
                        ></AccountSelfCreationConfigurationNoButton>          
                        <AccountSelfCreationConfigurationNoButton 
                            value={pageStrings.accountSelfCreationPage.formItem_formConfiguration_required_option}  
                            label={pageStrings.accountSelfCreationPage.formItem_emailAddress_label} 
                        ></AccountSelfCreationConfigurationNoButton>                        
                        <AccountSelfCreationConfigurationNoButton 
                            value={pageStrings.accountSelfCreationPage.formItem_formConfiguration_required_option}  
                            label={pageStrings.accountSelfCreationPage.formItem_username_label} 
                        ></AccountSelfCreationConfigurationNoButton>
                        <AccountSelfCreationConfigurationNoButton 
                            value={pageStrings.accountSelfCreationPage.formItem_formConfiguration_required_option}  
                            label={pageStrings.accountSelfCreationPage.formItem_password_label} 
                        ></AccountSelfCreationConfigurationNoButton> 
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={telephoneSelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_phoneNumber_label} 
                            disabled={!accountSelfCreationEnabled}                          
                            onChange={handleTelephoneSelection}
                        ></AccountSelfCreationConfiguration>
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={locationSelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_location_label} 
                            disabled={!accountSelfCreationEnabled}                            
                            onChange={handleLocationSelection}
                        ></AccountSelfCreationConfiguration>
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={titleSelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_title_label}  
                            disabled={!accountSelfCreationEnabled}                                                       
                            onChange={handleTitleSelection}
                        ></AccountSelfCreationConfiguration>
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={departmentSelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_department_label}  
                            disabled={!accountSelfCreationEnabled}
                            onChange={handleDepartmentSelection}
                        ></AccountSelfCreationConfiguration>
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={practiceAreaSelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_practiceArea_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handlePracticeAreaSelection}
                        ></AccountSelfCreationConfiguration>
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={userProfileSelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_userProfile_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleUserProfileSelection}
                        ></AccountSelfCreationConfiguration>

                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={street1Selection} 
                            label={pageStrings.accountSelfCreationPage.formItem_street1_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleStreet1Selection}
                        ></AccountSelfCreationConfiguration> 
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={street2Selection} 
                            label={pageStrings.accountSelfCreationPage.formItem_street2_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleStreet2Selection}
                        ></AccountSelfCreationConfiguration> 
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={citySelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_city_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleCitySelection}
                        ></AccountSelfCreationConfiguration>  
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={stateSelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_state_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleStateSelection}
                        ></AccountSelfCreationConfiguration>  
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={countrySelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_country_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleCountrySelection}
                        ></AccountSelfCreationConfiguration> 
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={zipCodeSelection} 
                            label={pageStrings.accountSelfCreationPage.formItem_zipCode_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleZipCodeSelection}
                        ></AccountSelfCreationConfiguration>                         
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={userCustomString1Selection} 
                            label={pageStrings.accountSelfCreationPage.formItem_userCustomString1_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleUserCustomString1Selection}                            
                        ></AccountSelfCreationConfiguration>  
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={userCustomString2Selection} 
                            label={pageStrings.accountSelfCreationPage.formItem_userCustomString2_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleUserCustomString2Selection}
                        ></AccountSelfCreationConfiguration>  
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={userCustomString3Selection} 
                            label={pageStrings.accountSelfCreationPage.formItem_userCustomString3_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleUserCustomString3Selection}
                        ></AccountSelfCreationConfiguration>  
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={userCustomString4Selection} 
                            label={pageStrings.accountSelfCreationPage.formItem_userCustomString4_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleUserCustomString4Selection}
                        ></AccountSelfCreationConfiguration>  
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={userCustomString5Selection} 
                            label={pageStrings.accountSelfCreationPage.formItem_userCustomString5_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleUserCustomString5Selection}
                        ></AccountSelfCreationConfiguration>  
                        <AccountSelfCreationConfiguration 
                            visibilityOptionValue={userCustomString6Selection} 
                            label={pageStrings.accountSelfCreationPage.formItem_userCustomString6_label}  
                            disabled={!accountSelfCreationEnabled}                           
                            onChange={handleUserCustomString6Selection}
                        ></AccountSelfCreationConfiguration>    
                    </div>                   
                </section>           
                <div className={styles['AccountSelfCreationDetailPane-blank']}></div>
                <Divider></Divider>
                <div className={styles['AccountSelfCreationDetailPane-actions']}>        
                    <div>
                        <FilledButton type={"submit"} value={pageStrings.accountSelfCreationPage.button_save_label} iconName="save"></FilledButton>
                    </div>
                </div>
            </Form>
        </>
    );

}


function visibilityOptionInitialValue(vo: number){
    if(vo)
    {
        if (vo.toString() === VisibilityOption.Required.toString()){
         
         return VisibilityOption.Required;
  
        } else if (vo.toString() === VisibilityOption.Optional.toString()) {
            
            return VisibilityOption.Optional;
            
        } else if (vo.toString() === VisibilityOption.Hidden.toString()){
            
            return VisibilityOption.Hidden;
            
        }
        
    }
    return VisibilityOption.Hidden;
  
  }

function approvalRequestEmailInitialValue(are: number){
 
    if(are)
    {

        if (are.toString() === ApprovalRequestEmail.DontSend.toString()){
            
            return ApprovalRequestEmail.DontSend;
            
        } else if (are.toString() === ApprovalRequestEmail.SendToSystemAdministrator.toString()){
            
            return ApprovalRequestEmail.SendToSystemAdministrator;
            
        } else if (are.toString() === ApprovalRequestEmail.SendToSpecificEmailAddress.toString()) {
            
            return ApprovalRequestEmail.SendToSpecificEmailAddress;
        }

    }
    
    
    return ApprovalRequestEmail.DontSend;
    
  }